export const COMPUTED_SUBSTITUTIONS: string = "Computed Substitutions";
export const PROMOTE: string = "Promote";
export const YES: string = "Yes";
export const CANCEL: string = "Cancel";
export const GENERATE: string = "Generate";
export const COMMEND: string = "Commend";
export const EMPTY_LOGS_MESSAGE: string = "Click on Generate to get the latest model for promotion";
export const ARS_GENERATION_SUCCESS: string = "ARS generation started ...";
export const NO_LOGS_FOUND: string = 'Logs not found';
export const LOGS: string = 'ARS Logs';
export const ARS_GENERATE_MESSAGE: string = "ARS Generation will now start and may take a couple of hours.";
export const PROCEED: string = "Would you like to proceed?";
export const CONFIRM_MESSAGE: string = "Confirm ARS Generate";
export const COPY: string = "Copy";
export const STATUS: string = "Status";
export const APPLET: string = "Applet";
export const CREATED: string = "Created";
export const UPDATED_BY: string = "Updated by";
export const LAST_UPDATED: string = "Last Updated";
export const SHOW_ONLY_OVERRIDDEN: string = "Show only overridden";
export const SHOW_ONLY_OVERRIDDEN_MESSAGE: string = "Overridden categories are those already assigned to other submodels. These categories cannot be modified here as they are actively managed in another submodel.";
export const SET_MODES_PRIORITY_STRING: string = "Set Modes Priority"
export const TITLE: string = "Title"
export const MIN_NUM_PRODUCTS: string = "minNumProducts"
export const DEFAULT_SUBMODEL: string = "Default Submodel"
export const CATEGORIES: string = "Categories"
export const BASE_CATEGORIES: string = "Base Categories"
export const TARGET_CATEGORIES: string = "Target Categories"
export const SELECTED_CATEGORIES: string = "Selected Categories"
export const SELECT_CATEGORIES: string = "Select Categories"
export const ALL_CATEGORIES: string = "All Categories"
export const NO_CATEGORY_FOUND_SEARCH_MESSAGE: string = "No category found matching your search"
export const NO_CATEGORIES_AVAILABLE_MESSAGE: string = "No categories available"
export const SORRY: string = "Sorry!"
export const VIEW_LESS: string = "View Less"
export const VIEW_MORE: string = "View More"
export const LIVE: string = 'Live';
export const YES_PROCEED: string = 'Yes, Proceed';
export const DRAFT: string = 'Draft';
export const GENERATE_MODEL: string = 'Generate Model';
export const MODEL_TO_GENERATE: string = 'Selected model to generate';
export const GENERATE_MESSAGE: string = 'ARS Generation may take a couple of hours. Would you like to proceed?';
export const CREATE: string = 'Create Model';
export const RECOMMENDER_CREATE: string = "recommender_create";
export const RECOMMENDER_READ: string = "recommender_read";
export const RECOMMENDER_UPDATE: string = "recommender_update";
export const RECOMMENDER_DELETE: string = "recommender_delete";
export const RECOMMENDER_GENERATE: string = "recommender_generate";
export const RECOMMENDER_PROMOTE: string = "recommender_promote";
export const INVOICE_PERIOD_FOR_HISTORICAL_DATA: string = "Invoice Period for historical data";
export const SELECT_PERIOD: string = "Select Period";
export const SELECT_MONTH: string = "Select Month";

export const hotSellerInvoicePeriods = [
    'Last 3 Months',
    'Last 6 Months',
    'Last 9 Months',
    'Last 12 Months',
    'All',
    'Custom Date'
] as const;

export const seasonalPeriods = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December', 'Custom Date'
] as const;

export const seasonalYearSpans = ["Last 1 Year", "Last 2 Year", "Last 3 Year", "Last 4 Year", "Last 5 Year", "Last 6 Year", "All Years"] as const;

export const SET_MODES_PRIORITY_OBJECT: any = {
    basic_coseller: {
        title: "BASIC CO-SELLER",
        description: "Co-selling products, based on order data only",
    },
    compatible_coseller: {
        title: "COMPATIBLE CO-SELLER",
        description: "Basic co-sellers, filtered further by compatibility rules",
    },
    hot_seller: {
        title: "HOT SELLER",
        description: "Products based on popularity",
    },
    computed_substitution: {
        title: "COMPUTED SUBSTITUTION",
        description: "Substituting products",
    },
    seasonal: {
        title: "SEASONAL",
        description:
            "Products based on time series analysis of order data over multiple time periods in a year",
    },
    expert_curated_coseller: {
        title: "EXPERT CURATED CO-SELLER",
        description:
            "Basic co-sellers, filtered further by category relevancy set by an SME",
    },
    featured_items: {
        title: "Featured Items",
        description:
            "Top-selling products selected from Top N high-performing categories, used to provide diverse recommendations as a fallback option",
    },
    stipulated_substitution: {
        title: "Stipulated Substitutions",
        description:
            "Substitute products manually configured by the merchant and sent using the Substitutes feed",
    },
    stipulated_co_seller: {
        title: "Stipulated Cosellers",
        description:
            "Co-selling products manually configured by the merchant and sent using the Related Products feed",
    },
    pure_compatibility: {
        title: "Pure compatibility",
        description:
            "Compatible products determined exclusively by compatibility rules, without using any order or quote data",
    },
};